import React from "react";
import Marquee from "react-fast-marquee";

// Slow editorial outlined marquee used as a section divider.
export default function EditorialMarquee({ text = "The Baking Company", dark = false, speed = 28 }) {
  const items = Array(6).fill(text);
  return (
    <div className={`py-10 md:py-14 overflow-hidden select-none ${dark ? "bg-clara-bg" : "bg-cream"}`} aria-hidden="true">
      <Marquee speed={speed} gradient={false}>
        {items.map((it, i) => (
          <span
            key={i}
            className={`font-serif text-stroke text-[13vw] md:text-[9vw] leading-none pr-10 ${dark ? "text-clara-accent/50" : "text-ink/25"}`}
          >
            {it} <span className="not-italic">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
